import React, { ChangeEvent } from "react";

type RadioListProps = {
  checked: boolean;
  label: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

type RadioFieldBoxProps = {
  label: string;
  required?: boolean;
  list: RadioListProps[];
  itemStart?: boolean;
}

export const RadioList: React.FC<RadioListProps> = ({checked, label, onChange}) => (
  <li className="list-radio__item">
    <label className="checkbox-item correct-box__form-check">
      <input type="radio" checked={checked} onChange={onChange} />
      <span className="checkmark"></span> {label} 
    </label>
  </li>
);

export const RadioFieldBox: React.FC<RadioFieldBoxProps> = ({ label, required =false, list, itemStart=true}) => (
  <div className={`contact-box__item ${itemStart ? "contact-box__item--start" : ""}`}>
    <label className="contact-box__ttl">
      <span>{label}</span>
      {required && <small>必須</small>}
    </label>
    <div className="contact-box__ct">
      <ul className="list-radio">
        {list.map((item, index) => (
          <RadioList key={index} {...item} />
        ))}
      </ul>
    </div>
  </div>
);